import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { isPlatformSystemAdmin } from '../utils/roleUtils';

/**
 * Use inside ProtectedRoute. Only platform administrators may view the wrapped page.
 */
const PlatformAdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  if (!user) {
    return null;
  }
  if (!isPlatformSystemAdmin(user)) {
    return <Navigate to="/dashboard/customer" replace />;
  }
  return <>{children}</>;
};

export default PlatformAdminRoute;
